import { FC, useState, useEffect } from 'react';
import { resetStore } from '../../common';

interface StoreProviderProps {
	children: JSX.Element;
	store: () => void;
	page: string;
}

export const StoreProvider: FC<StoreProviderProps> = ({ children, store, page }): JSX.Element | null => {
	const [current, setCurrent] = useState('');

	useEffect(() => {
		store();
		setCurrent(page);
		return () => resetStore();
	}, [page]);

	return page === current ? children : null;
};
